import * as React from 'react';

type Props = {
  programmeName: string;
  programmeStatus?: string;
  selectionMode?: string;
  isCompleted?: boolean;
  canOpenActivationPreview: boolean;
  onActivateClick: () => void;
  onBackClick: () => void;
};

const getStatus = (status: string | undefined, isCompleted: boolean | undefined) => {
  if (isCompleted) return { label: 'Completed', className: 'isCompleted' };

  const normalized = String(status || 'DRAFT').toUpperCase();
  if (normalized === 'ACTIVE') return { label: 'Active', className: 'isActive' };
  if (normalized === 'DRAFT') return { label: 'Draft', className: 'isDraft' };

  return {
    label: normalized
      .toLowerCase()
      .split('_')
      .filter(Boolean)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' '),
    className: 'isCompleted'
  };
};

export const ClubProgrammeBookingsPageHeader: React.FC<Props> = ({
  programmeName,
  programmeStatus,
  selectionMode,
  isCompleted,
  canOpenActivationPreview,
  onActivateClick,
  onBackClick
}) => {
  const status = getStatus(programmeStatus, isCompleted);
  const normalizedMode = String(selectionMode || '').toUpperCase();
  const modeLabel =
    normalizedMode === 'PRIORITY' ? 'Priority ranking' : normalizedMode === 'SINGLE' ? 'Single choice' : '';

  return (
    <header className="pbPageHeader">
      <div className="pbPageHeaderMain">
        <button type="button" className="pbBackLink" onClick={onBackClick}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m14.5 5-7 7 7 7" />
          </svg>
          <span>Back to activity programmes</span>
        </button>

        <div className="pbPageTitleRow">
          <h1>{programmeName}</h1>
          <span className={`pbHeaderStatus ${status.className}`}>
            <span aria-hidden="true" />
            {status.label}
          </span>
          {modeLabel ? (
            <span className="pbHeaderMode">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m13 2-9 12h7l-1 8 10-12h-7z" />
              </svg>
              {modeLabel}
            </span>
          ) : null}
        </div>

        <p className="pbPageMeta">
          Process and confirm programme allocations. Selections stay pending until you confirm.
        </p>
      </div>

      <div className="pbPageHeaderActions">
        <button
          type="button"
          className="pbHeaderPrimaryButton"
          disabled={!canOpenActivationPreview}
          onClick={onActivateClick}
          title={
            canOpenActivationPreview
              ? 'Preview and activate programme clubs'
              : 'Please confirm all pending programme allocations before activating clubs'
          }
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 5h8M6 9h12M5 13h14M7 17h10M9 21h6" />
          </svg>
          Preview and activate clubs
        </button>
      </div>
    </header>
  );
};
